<template>
  <div class="auth" id="auth" name="auth">
    <div class="top">
      <NavTop activeIndex="3"></NavTop>
    </div>
    <div
      class=""
      style="
        height: 666px;
        border: 1px solid #000;
        background-color: #25284c;
        padding-top: 10px;
        margin-top: 70px;
      "
    >
      <div
        class=""
        style="
          width: 1150px;
          margin: 0 auto;
          display: flex;
          justify-content: space-between;
          height: 648px;
          border-radius: 8px 8px 0 0;
        "
      >
        <div
          class=""
          style="
            background-color: #25284c;
            flex: 1;
            display: flex;
            flex-direction: column;
          "
        >
          <div class="" style="width: 1150px">
            <div id="" style="position: relative">
              <liveTv
                :islive="detail.islive"
                path="live"
                :reserve="reserve"
                :info="detail"
              ></liveTv>
            </div>
          </div>
        </div>
      </div>
    </div>
    <div class="" style="width: 1200px; margin: 20px auto">
      <!-- 推荐视频 -->
      <div
        class=""
        style="margin-bottom: 10px; margin-top: 20px; font-size: 24px"
      >
        视频推荐
      </div>
      <myList1 :list="list1"></myList1>
    </div>
  </div>
</template>
<script>
import NavTop from "../components/NavTopWhit.vue";
import myList1 from "../components/MyList1.vue";
import liveTv from "../views/live-tv.vue";
import { getLiveDetail1, getLivelist, getsaichenglist } from "../api/user";
import TencentCloudChat from "@tencentcloud/chat";
export default {
  components: {
    NavTop,
    myList1,
    liveTv,
  },
  data() {
    return {
      showTips: false,
      showTips1: false,
      tabLizt: ["聊天室", "排行榜"],
      list1: [], //全部

      current: 0,
      current1: 0,
      digShow: false,
      detail: {
        away_logo: "",
        away_name: "",
        clarity: {},
        clicktime: 1747287486,
        deletetime: 0,
        home_logo: "",
        home_name: "",
        hotvotes: 0,
        id: 200,
        is_home: 0,
        is_live: 0,
        ishot: 0,
        islive: 1,
        isliveName: "Live",
        isrecommend: 0,
        live_duration: "",
        match_id: 0,
        match_time: "",
        pull: "",
        push: "",
        starttime: 0,
        stream: "",
        thumb: "",
        title: "【BAT】CHEUN / CHOI vs KUSUM / PRATI",
        type: 2,
        typeName: "Lain",
        uid: 174,
        viewers: 1011,
      },
      reserve: {},
      userData: "",
      basketball: "",
      heat: "",
      id: "",
      couseList: [],
      userInfo: {},
      message: "",
      roomid: "",
      userID: "",
      userSign: "",
    };
  },
  created() {
    window.scrollTo(0, 0);

    console.log("接收过来的参数", this.$route.query.id);
    this.getList();
  },
  watch: {
    "$route.query": {
      handler(newQuery) {
        console.log(newQuery);
        console.log(newQuery.id);
        console.log(this.id);
        this.id = newQuery.id;
        this.getDetail();
      },
      deep: true,
      immediate: true, // 添加 immediate 属性
    },
  },
  methods: {
    getDetail() {
      getLiveDetail1({ id: this.id }).then((res) => {
        this.detail.pull =
          "https://402.sxlingchuangkeji.com/live/" +
          res.data.streams[0].streamName +
          ".m3u8";
      });
    },
    getList() {
      this.loading = true;
      getLivelist().then((res) => {
        console.log("全部直播列表", res);
        this.loading = false;
        this.list1 = res.data.data;
      });
    },
  },
};
</script>

<style scoped>
.active {
  font-weight: bold;
  font-size: 15px;
}

.active1 {
  background-color: #4b72f6 !important;
}

/*隐藏滚动条*/
.scroll_wrapper1::-webkit-scrollbar {
  display: none;
}

.goodsBox div:nth-child(5n) {
  margin-right: 0 !important;
}

.notice-box {
  width: 175px;
  color: #333;
  background: #ffffff;
  box-shadow: 0px 1px 12px 0px rgba(0, 0, 0, 0.2);
  border-radius: 2px;
  box-sizing: border-box;
  position: absolute;
  right: -80px;
  padding-bottom: 30px;
  top: 25px;
}

.notice-box .notice-title {
  text-align: center;
}

.notice-box .line {
  width: 196px;
  height: 1px;
  border-bottom: 1px solid #e6e6e6;
  margin-top: 20px;
}

.notice-box .notice-item {
  margin-top: 20px;
}

.notice-box .seemore a {
  text-align: center;
  color: #4b72f6;
  margin-top: 20px;
  display: flex;
  justify-content: center;
}

.gogngaoBox:hover {
  height: 150px !important;
}

.isLogin {
  background-color: #4b72f6 !important;
}
</style>
